module.exports = __webpack_public_path__ + "img/nav6.72161da1.png";